module.exports = __webpack_public_path__ + "static/media/team-04.888bc366.jpeg";